import React, { useEffect, useState } from 'react';
import { Alert, AlertTitle, Chip } from '@mui/material';
import { useAuth } from '../../hooks/useAuth';
import { aprilscherzService } from '../../services/aprilscherzService';
import { dismissApril, isAprilDismissed } from '../../utils/easterEggs';

/** Hinweis nur am 1. April, wenn der Admin-Schalter an ist. Wegklicken speichert lokal, nicht in der Datenbank. */
const AprilscherzBanner: React.FC = () => {
  const { user } = useAuth();
  const [jahr, setJahr] = useState<number | null>(null);

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    aprilscherzService
      .getStatus({ quiet: true })
      .then((status) => {
        if (cancelled) return;
        if (status.anzeigen && !isAprilDismissed(user.id, status.jahr)) {
          setJahr(status.jahr);
        }
      })
      .catch(() => {
        // Der Hinweis ist optional. Ein Fehler darf das Dashboard nicht stören.
      });
    return () => {
      cancelled = true;
    };
  }, [user]);

  if (!user || jahr === null) return null;

  return (
    <Alert
      severity="info"
      sx={{ mb: 2 }}
      onClose={() => {
        dismissApril(user.id, jahr);
        setJahr(null);
      }}
    >
      <AlertTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        Heutige Lage
        <Chip label="Aprilscherz" size="small" color="secondary" />
      </AlertTitle>
      CVE-2026-COFFEE: Kaffeemaschine out of scope. CVSS 11.0, Vektor: AV:K/AC:L/PR:N.
      Nichts davon wird gespeichert.
    </Alert>
  );
};

export default AprilscherzBanner;
